import { render } from "./LocalizedLink.vue?vue&type=template&id=1ab5f5aa"
import script from "./LocalizedLink.vue?vue&type=script&lang=js"
export * from "./LocalizedLink.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__